import { Controller } from "stimulus"

// Copy text to clipboard with visual feedback.
//
// Usage (copy from target element):
//   .div{"data-controller" => "clipboard"}
//     %span{"data-clipboard-target" => "source"} Text to copy
//     %button{"data-action" => "click->clipboard#copy"} Copy
//     %span.d-none{"data-clipboard-target" => "feedback"} Copied!
//
// Usage (copy a specific value):
//   %button{"data-controller" => "clipboard", "data-clipboard-value-value" => "some-text", "data-action" => "click->clipboard#copy"} Copy Code
//
export default class extends Controller {
  static targets = ["source", "feedback"]
  static values = {
    value: String
  }

  copy() {
    var text = this.hasValueValue ? this.valueValue : this.sourceTarget.textContent.trim()
    var controller = this

    navigator.clipboard.writeText(text).then(function() {
      controller.showFeedback()
    })
  }

  showFeedback() {
    var controller = this
    if (this.hasFeedbackTarget) {
      this.feedbackTarget.classList.remove("d-none")
      setTimeout(function() {
        controller.feedbackTarget.classList.add("d-none")
      }, 2000)
    }
  }
}
